import { EPredicateFields } from '@common/definitions';
import type {
  Predicate,
  NetworkPredicate,
  FunctionPredicate,
  UserPredicate,
  Filters,
} from '@common/types/objects';

const findFilters = <Y, T extends Record<string, Y>>(ids: string | string[] | undefined, storedItems: T): Y[] => {
  if (!ids) return [];

  return (Array.isArray(ids) ? ids : [ids])
    .map((id) => storedItems[id])
    .filter((item) => !!item);
};

export const predicatesToFilters = (
  predicates: Predicate[] = [],
  // TODO any for now, this whole function needs to be changed drastically
  // or deleted, see https://flex-appeal.atlassian.net/browse/PD-8853
  state: any
): Filters => {
  const networkFilter = predicates.find(
    (predicate): predicate is NetworkPredicate => predicate.attribute === EPredicateFields.NETWORK,
  );
  const functionFilter = predicates.find(
    (predicate): predicate is FunctionPredicate => predicate.attribute === EPredicateFields.FUNCTION,
  );
  const userFilter = predicates.find(
    (predicate): predicate is UserPredicate => predicate.attribute === EPredicateFields.USER,
  );
  const userCount = userFilter?.value && Array.isArray(userFilter.value) ? (userFilter.value as string[]).length : 0;

  return {
    networks: findFilters(networkFilter?.value, state.networks.items),
    functions: findFilters(functionFilter?.value, state.organisation.functions.items),
    users: findFilters(userFilter?.value, state.users.items),
    userCount,
  };
};
